import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoginStorage } from '../../login/login.storage';
import { LoaderService } from '../../shared/loader/loader.service';
import { environment } from '../../../environments/environment';
import { OmniRestService } from '../omni-rest.service';


@Injectable()
export class OmniPagamentoFlexivelService extends OmniRestService{

  public auth: { login: string; token: string };

  constructor(http: HttpClient, loaderService: LoaderService, loginStorage: LoginStorage, router: Router) {
        super(http, loaderService, loginStorage, router);
      }

  getBaseUrl(): string {
       return environment.URL_RODAS;
    }
  getHeaders() {
    return {
      'Content-Type': 'application/json',
      'omni-autenticacao': this.auth
        ? JSON.stringify(this.auth)
        : this.loginStorage.loginAndTokenAsJson,
    };
  }
}